import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Capture and strip any URL hash BEFORE React mounts so deep links like
// "/#writing" don't leave the app "stuck" on that fragment. A permanent
// listener strips any hash that a late fragment-navigation re-adds.
const stripHash = () => {
  if (window.location.hash) {
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }
};
window.__initialHash = window.location.hash ? window.location.hash.slice(1) : "";
stripHash();
window.addEventListener("hashchange", stripHash);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
